// This function is used with the calendar display in CatalogueCalendar.js and is copied from a video by 
// Daily Web Coding, "Build a react tailwind calendar ui from scratch", YouTube (1 November 2022), last 
// viewed: 13 March 2024: https://www.youtube.com/watch?v=s9-K02CP8hw 

export function cn(...classes) {
    return classes.filter(Boolean).join(" ");
}